"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distinct = void 0;
exports.inputRedundancy = inputRedundancy;
exports.whitelistCidrBlockToArray = whitelistCidrBlockToArray;
exports.edgifyVaTr101 = edgifyVaTr101;
exports.group = group;
exports.canonicalizePortConfig = canonicalizePortConfig;
exports.formatVaSmpte2038 = formatVaSmpte2038;
exports.pick = pick;
exports.pickNonNullish = pickNonNullish;
exports.valuesToString = valuesToString;
exports.generateRandomMacAddress = generateRandomMacAddress;
exports.execAsync = execAsync;
exports.parseK8sMemoryString = parseK8sMemoryString;
const canonicalize_1 = require("./canonicalize");
const child_process_1 = require("child_process");
function inputRedundancy({ ports }) {
    return ((ports && ports[0] && ports[0].copies) || 1) > 1;
}
function whitelistCidrBlockToArray(whitelistCidrBlock) {
    return whitelistCidrBlock && whitelistCidrBlock.length > 0 ? [whitelistCidrBlock].flat() : [];
}
function edgifyVaTr101(tr101) {
    return {
        prio1: {
            TS_sync_loss: tr101.prio1['1'].count,
            Sync_byte_error: tr101.prio1['2'].count,
            PAT_error: tr101.prio1['3'].count,
            Continuity_count_error: tr101.prio1['5'].count,
            PMT_error: tr101.prio1['6'].count,
            PID_error: tr101.prio1['8'].count,
        },
        prio2: {
            Transport_error: tr101.prio2['1'].count,
            CRC_error: tr101.prio2['2'].count,
            PCR_error: tr101.prio2['3'].count,
            PCR_accuracy_error: tr101.prio2['6'].count,
            PTS_error: tr101.prio2['7'].count,
            CAT_error: tr101.prio2['8'].count,
        },
    };
}
function group(items, selector) {
    return items.reduce((acc, cur) => {
        const v = selector(cur);
        if (typeof acc[v] === 'undefined') {
            acc[v] = [];
        }
        acc[v].push(cur);
        return acc;
    }, {});
}
function canonicalizePortConfig(p) {
    return (0, canonicalize_1.canonicalize)({ ...p, meta: void 0 });
}
function formatVaSmpte2038(smpte2038) {
    const anc = Object.keys(smpte2038).reduce((acc, setting) => {
        acc[setting] = Object.keys(smpte2038[setting]).reduce((settingObj, flag) => {
            // eslint-disable-next-line no-param-reassign
            settingObj[flag] = smpte2038[setting][flag] ? 'yes' : 'no';
            return settingObj;
        }, {});
        return acc;
    }, {});
    return anc;
}
function pick(t, ...pickKeys) {
    if (!t) {
        return t;
    }
    const o = {};
    for (const k of pickKeys) {
        o[k] = t[k];
    }
    return o;
}
function pickNonNullish(t, ...pickKeys) {
    const o = {};
    for (const k of pickKeys) {
        const val = t[k];
        if (val == null) {
            continue;
        }
        o[k] = t[k];
    }
    return o;
}
function valuesToString(t) {
    const v = {};
    for (const k of Object.keys(t)) {
        v[k] = `${t[k]}`;
    }
    return v;
}
function generateRandomMacAddress() {
    return 'XX:XX:XX:XX:XX:XX'.replace(/X/g, () => Math.floor(Math.random() * 16).toString(16));
}
function maybeBufferToUtf8(b) {
    if (Buffer.isBuffer(b)) {
        return b.toString('utf8');
    }
    return b;
}
function execAsync(cmd, opts = {}) {
    return new Promise((res) => {
        (0, child_process_1.exec)(cmd, opts, (err, stdout, stderr) => {
            if (err) {
                return res([err, null]);
            }
            return res([null, { stdout: maybeBufferToUtf8(stdout), stderr: maybeBufferToUtf8(stderr) }]);
        });
    });
}
const distinct = (array, equals = (v1, v2) => v1 === v2) => {
    return array.reduce((acc, cur) => {
        if (!acc.find((v) => equals(v, cur))) {
            acc.push(cur);
        }
        return acc;
    }, []);
};
exports.distinct = distinct;
/**
 * k8sMemoryParser parses k8s memory string to bytes
 * @param input - string to parse
 * @returns number - parsed bytes
 * @example
 * k8sMemoryParser('1Gi') // 1073741824
 * k8sMemoryParser('1G') // 1000000000
 * k8sMemoryParser('1M') // 1000000
 * k8sMemoryParser('1024') // 1024
 */
function parseK8sMemoryString(input) {
    const memoryMultipliers = {
        '': 1,
        k: 1000,
        M: 1000 ** 2,
        G: 1000 ** 3,
        T: 1000 ** 4,
        P: 1000 ** 5,
        E: 1000 ** 6,
        Ki: 1024,
        Mi: 1024 ** 2,
        Gi: 1024 ** 3,
        Ti: 1024 ** 4,
        Pi: 1024 ** 5,
        Ei: 1024 ** 6,
    };
    const index = input.search(/[a-zA-Z]/);
    const number = input.slice(0, index);
    const unit = input.slice(index);
    if (index === -1) {
        return parseInt(input, 10);
    }
    if (unit in memoryMultipliers) {
        return parseInt(number, 10) * memoryMultipliers[unit];
    }
    return NaN;
}
//# sourceMappingURL=data:application/json;base64,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